export default __webpack_public_path__ + "static/media/slider1.47eceb6b.jpg";